import React, { useEffect, useState } from "react";
import "./Terms_Of_Services.css";
import { TermsAndConditionData, TermsConditiondata } from "../../utils/apis/master/Master";
import parse from "html-react-parser";
const Terms_Of_Services = () => {


  const [termsCondition, setTermsCondition] = useState();
  const getTermsConditionDetails = async () => {
    const res = await TermsAndConditionData();

    if (res?.success) {
      setTermsCondition(res?.data);
    } else {
      console.error('Error fetching  data:', res?.error);
    }
  }
  useEffect(() => {
    getTermsConditionDetails()
  }, []);
  return (
    <section className="Terms_Of_Services">
      <div className="container">
        <h5 className="terms_header">Terms of Service: Infinity Ladakh Taxi</h5>

        <div className="terms_dark_div">
          {/* <p className="terms_text"> */}
          {parse(termsCondition?.description || "")}
          {/* </p> */}
        </div>
      </div>

    </section>
  );
};

export default Terms_Of_Services;
